export const SliderArrow = ({ className, onClick, children }: { className?: string; onClick?: () => void; children: React.ReactNode }) => {
  return (
    <button
      style={{
        zIndex: 10,
        backgroundColor: 'transparent',
      }}
      className={`absolute top-1/2 -translate-y-1/2 rounded-none p-3 ${className} text-gray-100`}
      onClick={onClick}
    >
      {children}
    </button>
  );
};
